import React from 'react'

import { Typography } from '@telus-uds/components-web'
import { string } from 'prop-types'

import useTranslate from '../../../hooks/useTranslate'

const GiftLabel = ({ size }) => {
  const translate = useTranslate()

  return <Typography variant={{ size, bold: true }}>{translate('gift')}</Typography>
}

export default GiftLabel

GiftLabel.propTypes = {
  size: string.isRequired
}
